[
  {
    "image": "https://i.pinimg.com/originals/0a/e3/60/0ae360816748f01b50797ee053c0b7b5.jpg",
    "name": "Vincent van Gogh",
    "country": "Netherlands",
    "birthYear": 1853,
    "deathYear": 1890,
    "style": "Post-Impressionism",
    "famousWorks": ["Starry Night", "Sunflowers", "The Bedroom"]
  },
  {
    "image": "https://tse4.mm.bing.net/th/id/OIP.E5PHMHoS0DEvYl-gjm_i1QHaKK?rs=1&pid=ImgDetMain&o=7&rm=3",
    "name": "Pablo Picasso",
    "country": "Spain",
    "birthYear": 1881,
    "deathYear": 1973,
    "style": "Cubism",
    "famousWorks": ["Guernica", "Les Demoiselles d'Avignon", "The Weeping Woman"]
  },
  {
    "image": "https://tse1.mm.bing.net/th/id/OIP.DtC3ATqwhnlc_X8KeBv7aAHaJg?rs=1&pid=ImgDetMain&o=7&rm=3",
    "name": "Leonardo da Vinci",
    "country": "Italy",
    "birthYear": 1452,
    "deathYear": 1519,
    "style": "Renaissance",
    "famousWorks": ["Mona Lisa", "The Last Supper", "Vitruvian Man"]
  },
  {
    "image": "https://tse2.mm.bing.net/th/id/OIP.LbTmaWSjPH8tg1VzbQHJ8wHaKA?rs=1&pid=ImgDetMain&o=7&rm=3",
    "name": "Claude Monet",
    "country": "France",
    "birthYear": 1840,
    "deathYear": 1926,
    "style": "Impressionism",
    "famousWorks": ["Water Lilies", "Impression, Sunrise", "Woman with a Parasol"]
  },
  {
    "image": "https://tse1.mm.bing.net/th/id/OIP.hvkaRN4jmFNubkwlqDmZYgHaJO?rs=1&pid=ImgDetMain&o=7&rm=3",
    "name": "Salvador Dalí",
    "country": "Spain",
    "birthYear": 1904,
    "deathYear": 1989,
    "style": "Surrealism",
    "famousWorks": ["The Persistence of Memory", "Swans Reflecting Elephants", "Metamorphosis of Narcissus"]
  },
  {
    "image": "https://tse2.mm.bing.net/th/id/OIP.hgGeMiOTU-Ip1zfzysQIVAHaJ3?rs=1&pid=ImgDetMain&o=7&rm=3",
    "name": "Frida Kahlo",
    "country": "Mexico",
    "birthYear": 1907,
    "deathYear": 1954,
    "style": "Surrealism / Folk Art",
    "famousWorks": ["The Two Fridas", "Self-Portrait with Thorn Necklace", "The Broken Column"]
  },
  {
    "image": "https://cdn.britannica.com/46/75046-050-0973B0E8/Michelangelo.jpg",
    "name": "Michelangelo",
    "country": "Italy",
    "birthYear": 1475,
    "deathYear": 1564,
    "style": "Renaissance",
    "famousWorks": ["The Creation of Adam", "David", "Pieta"]
  },
  {
    "image": "https://tse4.mm.bing.net/th/id/OIP.vKfizNnZS9g-CIXh09iwkQHaHa?rs=1&pid=ImgDetMain&o=7&rm=3",
    "name": "Rembrandt",
    "country": "Netherlands",
    "birthYear": 1606,
    "deathYear": 1669,
    "style": "Baroque",
    "famousWorks": ["The Night Watch", "The Anatomy Lesson", "Self-Portraits"]
  }
]